import { useEffect } from "react";

const MANAGED_PRELOAD_ATTRIBUTE = "data-managed-preload";

const removeManagedPreloadLinks = (key) => {
  if (typeof document === "undefined") return;

  document.head
    .querySelectorAll(`link[${MANAGED_PRELOAD_ATTRIBUTE}="${key}"]`)
    .forEach((link) => link.remove());
};

const useHeadPreloadLinks = (key, links = []) => {
  const linkConfigString = JSON.stringify(links);

  useEffect(() => {
    if (typeof document === "undefined" || !key) return undefined;

    removeManagedPreloadLinks(key);

    JSON.parse(linkConfigString).forEach((attributes) => {
      const link = document.createElement("link");
      link.setAttribute(MANAGED_PRELOAD_ATTRIBUTE, key);

      Object.keys(attributes).forEach((attributeName) => {
        const value = attributes[attributeName];
        if (value) {
          link.setAttribute(attributeName, value);
        }
      });

      document.head.appendChild(link);
    });

    return () => removeManagedPreloadLinks(key);
  }, [key, linkConfigString]);
};

export default useHeadPreloadLinks;
